import React, { useState, useEffect } from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom'; 
import logoTFJA from '../assets/Logo_Tribunal_Federal_de_Justicia.png';
import fondoTFJA from '../assets/fondo.jpeg';

// const isTokenValid = (token: string): boolean => {
//   try {
//     const payload = JSON.parse(atob(token.split('.')[1])); // Decodifica el payload del JWT
//     const exp = payload.exp;
//     if (!exp) return false;
//     const now = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
//     return exp > now;
//   } catch (err) {
//     return false;
//   }
// };

const Home: React.FC = () => {
  const [user, setUser] = useState<{ username: string; name: string } | null>(null);
  const navigate = useNavigate();

  

   useEffect(() => {
  const storedUser = localStorage.getItem('userProfile');
  
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);

      if (parsedUser.status === 'AWAITING_APPROVAL') {
        navigate('/session-inactive');
      }
    } catch (error) {
      console.error('Failed to parse user profile', error);
      // Handle parsing error (e.g., clear invalid storage)
      localStorage.removeItem('userProfile');
    }
  }
}, [navigate]);

  return (
    <Container 
      maxWidth={false} // Hace que el contenedor ocupe todo el ancho de la pantalla
      disableGutters // Remueve los márgenes predeterminados del contenedor
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', // Centra el contenido verticalmente
      }}
    >
      <Box
  sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '1460px', // Ancho fijo de 1460px
    height: '388px', // Alto fijo de 388px
    gap: '40px', // Espacio entre elementos hijos de 40px
    pt: '32px', // padding-top de 32px (equivalente a paddingTop en MUI sx)
    pr: '360px', // padding-right de 360px
    pb: '32px', // padding-bottom de 32px
    pl: '360px', // padding-left de 360px
    borderRadius: '4px',
    backgroundImage: `url(${fondoTFJA})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: '#000000',
    fontFamily: 'Montserrat',
    fontSize: '40px',
    fontWeight: 600,
    lineHeight: '48.76px',
    boxSizing: 'border-box' // Asegura que el padding no afecte las dimensiones totales
  }}
>
        {/* Personalizando colores específicos en el texto */}
        <Typography 
  variant="h4" 
  component="h1" 
  sx={{ 
    mb: 2,
    color: '#000000',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '40px',
    lineHeight: '100%',
    letterSpacing: '0%',
    textAlign: 'center',
  }}
>
  <div>¡Hola, {user ? user.name : 'usuario'}!</div>
  <div style={{ color: '#002E74' }}>¡Nos alegra verte de nuevo!</div>
</Typography>
        {/* <Typography 
  variant="body1" 
  sx={{ 
    color: '#AAAAAA', // Cambiado a gris (#AAAAAA)
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '114.99999999999999%', // o 1.15
    letterSpacing: '0%',
    textAlign: 'center',
    mb: 3 // margen inferior
  }}
>
  Estamos trabajando en nuevas funcionalidades para mejorar tu experiencia. ¡Mantente atento a las actualizaciones!
</Typography> */}
      </Box>

      {/* Logo centrado */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <img
          src={logoTFJA}
          alt="Logo TFJA"
          style={{ maxWidth: '268px', height: 'auto', marginTop:'35px'}} // Ajusta el tamaño del logo
        />
      </Box>

    </Container>
  );
};

export default Home;
